document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hotspot-product-showcase').forEach(initHotspotSection);
});

function initHotspotSection(section) {
  const sectionId = section.getAttribute('data-section-id');
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  // Scoped elements per section
  const hotspotButtons = section.querySelectorAll('.showcase-image-section .showcase-hotspot-btn');
  const productSlides  = section.querySelectorAll('.product-slide');
  const prevBtn        = section.querySelector('.slider-nav .prev-btn');
  const nextBtn        = section.querySelector('.slider-nav .next-btn');
  const dots           = section.querySelectorAll('.slider-dots .dot');

  // Drawer (unique per section)
  const drawer       = document.getElementById(`mobile-hotspot-drawer-${sectionId}`);
  const drawerOverlay = document.getElementById(`mobile-drawer-overlay-${sectionId}`);
  const drawerClose  = drawer?.querySelector('.drawer-close');
  const drawerCancel = drawer?.querySelector('.drawer-cancel');
  const drawerSlider = drawer?.querySelector('.drawer-slider');
  const drawerSlides = drawer ? Array.from(drawer.querySelectorAll('.drawer-slide')) : [];
  const drawerHotspots = drawer ? Array.from(drawer.querySelectorAll('.drawer-hotspot')) : [];

  // Optional buttons and swatches inside this section only
  const wishlistBtns   = section.querySelectorAll('.wishlist-btn');
  const addToCartBtns  = section.querySelectorAll('.add-to-cart-btn');
  const colorSwatches  = section.querySelectorAll('.color-swatch');

  let current = 0;
  let autoTimer;

  if (!productSlides.length) return;
  showSlide(0);
  setupDesktop();
  setupMobile();
  startAuto();

  function setupDesktop() {
    hotspotButtons.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        if (isMobile()) {
          openDrawer(idx);
        } else {
          showSlide(idx);
          restartAuto();
        }
      });
    });

    prevBtn?.addEventListener('click', () => { prevSlide(); restartAuto(); });
    nextBtn?.addEventListener('click', () => { nextSlide(); restartAuto(); });

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => { showSlide(idx); restartAuto(); });
    });

    document.addEventListener('keydown', (e) => {
      if (isMobile()) return;
      if (!isInViewport(section)) return;
      if (e.key === 'ArrowLeft') { prevSlide(); restartAuto(); }
      if (e.key === 'ArrowRight') { nextSlide(); restartAuto(); }
    });

    // Optional: local behaviors inside this section
    colorSwatches.forEach(s => {
      s.addEventListener('click', () => {
        s.parentNode.querySelectorAll('.color-swatch').forEach(x => x.classList.remove('active'));
        s.classList.add('active');
      });
    });

    wishlistBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        toggleWishlist(btn);
      });
    });

    addToCartBtns.forEach(btn => {
      if (!btn.disabled) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          addToCart(btn);
        });
      }
    });
  }

  function setupMobile() {
    // Drawer hotspots
    drawerHotspots.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        showSlide(idx);
        updateDrawer();
      });
    });

    drawerClose?.addEventListener('click', closeDrawer);
    drawerCancel?.addEventListener('click', closeDrawer);
    drawerOverlay?.addEventListener('click', closeDrawer);

    // ✅ Add drawer nav arrows
    drawerSlides.forEach((slide, slideIndex) => {
    const drawerPrevBtn = slide.querySelector('.drawer-nav .prev-btn');
    const drawerNextBtn = slide.querySelector('.drawer-nav .next-btn');

    drawerPrevBtn?.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent bubbling
      prevSlide();
      updateDrawer();
    });

    drawerNextBtn?.addEventListener('click', (e) => {
      e.stopPropagation();
      nextSlide();
      updateDrawer();
    });
  });

    drawer?.addEventListener('click', (e) => {
      if (e.target === drawer) closeDrawer();
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) closeDrawer();
    });
  }

  function setupMediaCarousels() {
  if (!drawer || !isMobile()) return;

  const carousels = drawer.querySelectorAll('.drawer-media-carousel');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('.media-track');
    const dots  = Array.from(carousel.querySelectorAll('.media-dot'));
    const items = Array.from(track.querySelectorAll('.media-item'));
    if (!items.length) return;

    // distance between slides (accounts for 75% width + gap)
    const step = items[1]
      ? (items[1].offsetLeft - items[0].offsetLeft)
      : items[0].clientWidth;

    // dot click -> scroll to that frame
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: i * step, behavior: 'smooth' });
      });
    });

    // keep dots active while user swipes
    const update = () => {
      const idx = Math.round(track.scrollLeft / step);
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    };

    const onScroll = () => requestAnimationFrame(update);
    track.addEventListener('scroll', onScroll);
    window.addEventListener('resize', update);
    update();
  });
}


  function showSlide(index) {
    if (index < 0) index = productSlides.length - 1;
    if (index >= productSlides.length) index = 0;
    current = index;

    productSlides.forEach((el, i) => el.classList.toggle('active', i === current));
    hotspotButtons.forEach((el, i) => el.classList.toggle('active', i === current));
    dots.forEach((el, i) => el.classList.toggle('active', i === current));

    updateNav();
    updateDrawer();
  }
  function nextSlide() { showSlide(current + 1); }
  function prevSlide() { showSlide(current - 1); }
  function updateNav() {
    if (prevBtn) prevBtn.disabled = (current === 0);
    if (nextBtn) nextBtn.disabled = (current === productSlides.length - 1);
  }

  function startAuto() {
    if (productSlides.length <= 1 || isMobile()) return;
    stopAuto();
    autoTimer = setInterval(() => {
      if (current >= productSlides.length - 1) showSlide(0);
      else nextSlide();
    }, 5000);
  }
  function stopAuto() { if (autoTimer) clearInterval(autoTimer); }
  function restartAuto() { stopAuto(); startAuto(); }

 function openDrawer(index = current) {
    if (!drawer) return;
    showSlide(index);
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');

    if (drawerOverlay) {
      drawerOverlay.classList.add('active');
      drawerOverlay.setAttribute('aria-hidden', 'false');
    }

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }
    document.body.style.overflow = 'hidden';
    document.body.classList.add('drawer-open');
    section.classList.add('drawer-active');
    setupMediaCarousels?.();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');

    if (drawerOverlay) {
      drawerOverlay.classList.remove('active');
      drawerOverlay.setAttribute('aria-hidden', 'true');
    }

    setTimeout(() => {
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-open');
      document.documentElement.style.setProperty('--scrollbar-width', '0px');
    }, 450);
    section.classList.remove('drawer-active');
  }

  function updateDrawer() {
    if (!drawer) return;
    // If you use translate for the drawer slider, keep it. If you switched to "show only active",
    // the active class below is enough.
    if (drawerSlider) drawerSlider.style.transform = `translateX(-${current * 100}%)`;
    drawerSlides.forEach((el, i) => el.classList.toggle('active', i === current));
    drawerHotspots.forEach((el, i) => el.classList.toggle('active', i === current));
  }

  // Utilities and shared actions
  function isInViewport(el) {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0 && r.left < window.innerWidth && r.right > 0;
  }

  function getWishlist() { try { return JSON.parse(localStorage.getItem('product-wishlist') || '[]'); } catch { return []; } }
  function toggleWishlist(btn) {
    const productId = btn.dataset.productId;
    let list = getWishlist();
    if (list.includes(productId)) {
      list = list.filter(id => id !== productId);
      btn.classList.remove('active');
      notify('Removed from wishlist', 'info');
    } else {
      list.push(productId);
      btn.classList.add('active');
      notify('Added to wishlist ❤️', 'success');
    }
    localStorage.setItem('product-wishlist', JSON.stringify(list));
  }

  async function addToCart(btn) {
    const variantId = btn.dataset.variantId;
    const original = btn.textContent;
    btn.textContent = 'ADDING...'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error();
      btn.textContent = 'ADDED!'; btn.classList.add('added');
      notify('Product added to cart! 🛒', 'success');
      setTimeout(() => { btn.textContent = original; btn.disabled = false; btn.classList.remove('added'); }, 2000);
      updateCartCount();
    } catch {
      btn.textContent = 'TRY AGAIN';
      notify('Failed to add to cart. Please try again.', 'error');
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  }
  async function updateCartCount() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => el.textContent = cart.item_count);
    } catch {}
  }
  function notify(msg, type='info') {
    const n = document.createElement('div');
    n.style.cssText = 'position:fixed;top:20px;right:20px;background:' + (type==='success'?'#10b981':type==='error'?'#ef4444':'#6b7280') + ';color:#fff;padding:12px 16px;border-radius:6px;box-shadow:0 4px 12px rgba(0,0,0,.15);font-size:14px;z-index:9999;';
    n.textContent = msg;
    document.querySelectorAll('.showcase-notification').forEach(x => x.remove());
    n.className = 'showcase-notification';
    document.body.appendChild(n);
    setTimeout(() => n.remove(), 3000);
  }
   setupHotspotHoverModals(section);
}

// ---------------------------
// HOVER MODALS (desktop only)
// ---------------------------
function setupHotspotHoverModals(section) {
  const hotspots = section.querySelectorAll('.showcase-hotspot-btn');
  const modals = section.querySelectorAll('.hotspot-hover-modal');

  hotspots.forEach((hotspot, index) => {
    const modal = modals[index];
    if (!modal) return;

    let hoverTimer;
    let isHovering = false;

    hotspot.addEventListener('mouseenter', () => {
      if (window.matchMedia('(max-width: 768px)').matches) return;
      isHovering = true;
      clearTimeout(hoverTimer);

      // Update modal content from data attributes
      const title = hotspot.dataset.productTitle || '';
      const price = hotspot.dataset.productPrice || '';
      const comparePrice = hotspot.dataset.productCompare || '';
      const image = hotspot.dataset.productImage || '';
      const desc = hotspot.dataset.productDesc || '';
      const url = hotspot.dataset.productUrl || '#';

      if (modal.querySelector('.modal-product-title')) modal.querySelector('.modal-product-title').textContent = title;
      if (modal.querySelector('.modal-current-price')) modal.querySelector('.modal-current-price').textContent = price;
      if (modal.querySelector('.modal-compare-price')) {
        const cmp = modal.querySelector('.modal-compare-price');
        cmp.textContent = comparePrice;
        cmp.style.display = comparePrice ? 'inline' : 'none';
      }
      if (modal.querySelector('.modal-product-image')) modal.querySelector('.modal-product-image').src = image;
      if (modal.querySelector('.modal-product-desc')) modal.querySelector('.modal-product-desc').textContent = desc;
      if (modal.querySelector('.modal-view-btn')) modal.querySelector('.modal-view-btn').href = url;

      positionHoverModal(hotspot, modal);

      hoverTimer = setTimeout(() => {
        if (isHovering) modal.classList.add('show');
      }, 300);
    });

    hotspot.addEventListener('mouseleave', () => {
      isHovering = false;
      clearTimeout(hoverTimer);
      modal.classList.remove('show');
    });

    modal.addEventListener('mouseenter', () => { isHovering = true; modal.classList.add('show'); });
    modal.addEventListener('mouseleave', () => { isHovering = false; modal.classList.remove('show'); });
  });
}

function positionHoverModal(hotspot, modal) {
  modal.classList.remove('position-top');
  const hotspotRect = hotspot.getBoundingClientRect();
  const containerRect = hotspot.offsetParent.getBoundingClientRect();

  const hotspotTop = hotspotRect.top - containerRect.top;
  const hotspotLeft = hotspotRect.left - containerRect.left;
  const hotspotWidth = hotspot.offsetWidth;
  const hotspotHeight = hotspot.offsetHeight;

  const container = hotspot.offsetParent;
  const containerHeight = container.offsetHeight;
  const containerWidth = container.offsetWidth;

  let top = hotspotTop + hotspotHeight + 12;
  let left = hotspotLeft + (hotspotWidth / 2) - 140;

  if (top + 320 > containerHeight) {
    top = hotspotTop - 90 - 12;
    modal.classList.add('position-top');
  }

  if (left < 10) left = 10;
  if (left + 280 > containerWidth - 10) {
    left = containerWidth - 290;
  }

  modal.style.position = 'absolute';
  modal.style.top = top + 'px';
  modal.style.left = left + 'px';
}
